import { CheckCircle2, Trash2, MailOpen } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};
const WORD = { archived: "Archived", trashed: "Moved to Trash", dismissed: "Dismissed", noise: "Marked as junk", snoozed: "Snoozed", surfaced: "Published" };

const line = (r) => {
  if (r.status === "purged") {
    const who = r.actor ? `${r.actor} deleted it${r.at ? ` on ${fmt(r.at)}` : ""}` : "It was deleted";
    return `${who}, and it was emptied from the Trash for good${r.purged_at ? ` on ${fmt(r.purged_at)}` : ""}. Nothing left to open.`;
  }
  const what = WORD[r.status] || "Handled";
  const by = r.actor ? ` by ${r.actor}` : " automatically";
  return `${what}${by}${r.at ? ` · ${fmt(r.at)}` : ""}`;
};

// A report (or any old link) pointed at these emails; by the time it was clicked, someone else had
// already handled them. Says who and when, so an empty Inbox never reads as "what did I miss?".
export function MailFlagged({ rows, onOpen }) {
  const changed = (rows || []).filter((r) => !r.waiting);
  if (!changed.length) return null;
  const gone = changed.filter((r) => r.status === "purged").length;
  return (
    <div data-testid="mail-flagged-banner" className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 shrink-0 rounded-full bg-amber-100 p-1.5 text-amber-700">
          {gone === changed.length ? <Trash2 className="h-4 w-4" /> : <CheckCircle2 className="h-4 w-4" />}
        </span>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-ink" data-testid="mail-flagged-title">
            {changed.length === 1 ? "That email was already handled" : `${changed.length} of the emails in that link were already handled`}
          </div>
          <p className="mt-0.5 text-sm text-ink/70">
            Your report was a snapshot. Someone on the team got here first — nothing was missed.
          </p>
          <ul className="mt-3 space-y-2">
            {changed.map((r) => (
              <li key={r.id} data-testid={`mail-flagged-row-${r.id}`} className="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-sm">
                <span className="font-semibold text-ink">{r.subject || "(no subject)"}</span>
                <span className="text-ink/60" data-testid={`mail-flagged-line-${r.id}`}>{line(r)}</span>
                {r.status !== "purged" && (
                  <button type="button" data-testid={`mail-flagged-open-${r.id}`} onClick={() => onOpen(r)}
                    className="inline-flex items-center gap-1 font-semibold text-redline-600 hover:text-redline-700 underline decoration-redline-300 underline-offset-2 transition-colors">
                    <MailOpen className="h-3.5 w-3.5" /> Open it
                  </button>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
